module.exports = "/_next/static/images/houston-tx-5d76c80f37fc38c2effa895280edb34a.jpg";